/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiActionFromJSON, ApiActionToJSON, } from './ApiAction';
import { ApiFormRuleFromJSON, ApiFormRuleToJSON, } from './ApiFormRule';
import { ApiLocationFromJSON, ApiLocationToJSON, } from './ApiLocation';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiFormFromJSON(json) {
    return ApiFormFromJSONTyped(json, false);
}
export function ApiFormFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'actions': !exists(json, 'actions') ? undefined : (json['actions'].map(ApiActionFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'location': !exists(json, 'location') ? undefined : ApiLocationFromJSON(json['location']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'preventSubmit': !exists(json, 'preventSubmit') ? undefined : json['preventSubmit'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'rules': !exists(json, 'rules') ? undefined : (json['rules'].map(ApiFormRuleFromJSON)),
        'target': !exists(json, 'target') ? undefined : json['target'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiFormToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'actions': value.actions === undefined ? undefined : (value.actions.map(ApiActionToJSON)),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'id': value.id,
        'location': ApiLocationToJSON(value.location),
        'name': value.name,
        'preventSubmit': value.preventSubmit,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'rules': value.rules === undefined ? undefined : (value.rules.map(ApiFormRuleToJSON)),
        'target': value.target,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
